import React from "react";
import "swiper/css";
import useSWR from "swr";
import { Autoplay, Pagination } from "swiper/modules";
import { useMemo, useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { IoDocumentOutline } from "react-icons/io5";
import { FaVideo, FaFolder, FaImage, FaFileAudio, FaFile, FaRegStar, FaStar, FaStarHalfAlt, FaTag } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import "./styles/DetallesContenido.css";
import { useLocation, useParams } from 'react-router-dom';
import CardResennas from "./component/CardResennas";
import Card from "./component/Card";
import './component/stylesComponent/Carrusel.css';
import { useCarrito } from './component/Cart';
import {  Link } from 'react-router-dom';
import $ from "jquery";

const getProducto = async (url) => {
    try{
        const res = await fetch(url, {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        }) 

        if(!res.ok) throw new Error(`Error en la consulta ${url}`);

        return res.json();
    } catch(error){ console.error("Error al obtener los productos " + error.message); }
};

const DetalleContenido = () => {

    useEffect(() => {
    $(".principal").hide().fadeIn(500);

    return () => {
      $(".principal").stop(true, true).show();
    };
  }, []);

    const { id } = useParams();
    const { state: fromState } = useLocation();

    const { carrito, addItem } = useCarrito();

    //Usuario logueado
    const [usuario] = useState(() => {
            const usuarioAlmacenado = localStorage.getItem("userLogueado");
            return usuarioAlmacenado ? JSON.parse(usuarioAlmacenado) : null;
    });

    const [comprado, setComprado] = useState(null);
    const [compraId, setCompraId] = useState(null);
    const [numVentas, setnumVentas] = useState(null);

    const fallbackData = useMemo(() => ({
        producto: fromState?.producto,
        tutor: fromState?.tutor,
        resennas: [],
        rating: 0,
        productosRelacionados: [],
        sesiones: [],
        archivos: []
    }), [fromState]);

    let baseUrl;
    if(process.env.NODE_ENV === 'development') baseUrl = 'http://localhost:8080';
    else baseUrl='https://app-formacion.vercel.app';


    //Si se pasan los datos en el state se usa en fallback
    const { data: detalle, error, mutate: mutateProductos } = useSWR(
        `${baseUrl}/api/productos/${id}`,
        getProducto,
        {
            fallbackData, 
            revalidateOnMount: true,
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
            keepPreviousData: true,
            dedupingInterval: 30 * 60 * 1000,
        }
    );

    //Comprobar si ya ha comprado el producto
    useEffect(() => {
        if(!usuario || usuario.Tipo === "Tutor"){
            setComprado(false);
            return;
        }

        const comprobarCompra = async () => {
            try{
                const resp = await fetch(`${baseUrl}/api/compras/search/compra/${usuario._id}/${detalle.producto._id}`);
                if (!resp.ok) throw new Error("Error al comprobar compra");
                const data = await resp.json();

                setComprado(data.comprado);

                if (data.comprado && data.compraId) {
                    setCompraId(data.compraId);
                }
            } catch (err) {
                console.error(err);
                setComprado(false);
            }
        };
        comprobarCompra();
    }, [usuario, detalle]);

    // Comprobar número de ventas para clases no particulares
    useEffect(() => {
        if (!detalle?.producto) return;

        // Solo para productos que no sean claseParticular y que tengan plazas definidas
        if (
        detalle.producto.tipo !== "claseParticular" && detalle.producto.Plazas != null) {
        const fetchVentas = async () => {
            try {
            const resp = await fetch(
                `${baseUrl}/api/compras/search/contenido/${detalle.producto._id}`
            );
            if (!resp.ok) throw new Error("Error al obtener ventas por contenido");
            const datos = await resp.json();
            //La API devuelve un array de compras; contamos su longitud:
            setnumVentas(Array.isArray(datos) ? datos.length : 0);
            } catch (err) {
            console.error(err);
            setnumVentas(0);
            }
        };
        fetchVentas();
        }
    }, [detalle]);

    if (error) {
        return (
            <div className="principal">
                <p style={{ textAlign: "center", fontStyle: "italic", marginTop: "2rem" }}>Error al cargar detalle: {error.message}</p>;
            </div>
        )
    }
    if (!detalle?.producto || !detalle?.tutor ) {
        return (
            <div className="principal">
                <p style={{ textAlign: "center", fontStyle: "italic", marginTop: "2rem" }}>Cargando detalles...</p>
            </div>
        )
        
    }

    // Desestructuramos todo lo que el servidor ya nos devuelve
    const {
        producto,
        tutor,
        resennas,
        rating,
        productosRelacionados,
        sesiones,
        archivos,
    } = detalle;

    //Comprobar si el producto existe
    const estaEliminado = producto.Nombre === null &&
                          producto.Descripcion === null &&
                          producto.Tematica === null &&
                          producto.ImagenPortada === null &&
                          producto.FechaSubida === null;


    if (estaEliminado) {
        return (
            <div className="principal">
                <p style={{ textAlign: "center", fontStyle: "italic", marginTop: "2rem" }}>
                    Este producto fue eliminado por su autor.
                </p>
            </div>
        );
    }

    //Mostrar un icono otro según el tipo de archivo
    const getIcono = (archivo) => {
        if(archivo.isDirectory) return <FaFolder />;
        else{
            switch (archivo.tipo){
                case 'Documento': return <IoDocumentOutline />;
                case 'Video': return <FaVideo />;
                case 'Audio': return <FaFileAudio />;
                case 'Foto': return <FaImage />;
                case 'Desconocido': return <FaFile />;
                default: return <FaFile />; 
            }
        }
    };

    const añadido = carrito.some((p) => p._id === producto._id);

    const manejarAddCarrito = () => {
        if(!añadido){
            addItem({
                _id: producto._id,
                ImagenPortada: producto.ImagenPortada,
                Nombre: producto.Nombre,
                Precio: producto.Precio,
                cantidad: 1,

            })
        }
    }

    

   return(
        <div className="principal">
            <div className='infoContenido'>
                <div className="infoPrincipal">

                    <div className="imagenPrecio">
                        <img src={`data:image/png;base64,${producto.ImagenPortada}`} alt={`${producto.Nombre}`} />

                        <div className="precioVal">
                            <div className="detallesItem">
                                <h4 className="label">Valoración: </h4>
                                <span className="value">
                                    {Array.from({length: 5}, (_, index) =>{
                                        const entero = Math.floor(rating);
                                        const decimal = rating - entero;

                                        if(index < entero) {
                                            return <FaStar key={index} style={{color: '#f67034'}} />;
                                        }
                                        else if (index === entero && decimal > 0.4){
                                            return <FaStarHalfAlt key={index} style={{color: '#f67034'}} />;
                                        }
                                        else{
                                            return <FaRegStar key={index} />;
                                        }
                                    })}
                                </span>
                            </div>

                            <div className="detallesItem">
                                <h4 className="label">Precio: </h4>
                                <span className="value"><strong>{(producto.Precio).toFixed(2)} €  <FaTag /></strong></span>
                            </div>

                            {usuario?.Tipo === "Tutor" ? (
                                <span>Crea una cuenta de cliente para comprar este producto</span>
                            ) : comprado === null ? (
                                <span>Cargando estado de compra…</span>
                            ) : comprado === true ? (
                                <span>
                                    Ya has comprado este contenido.
                                    <br />
                                    <Link style={{color: 'var(--enlace'}} to={`/compra/exitosa/${compraId}`}>
                                        Haz clic aquí para ver el producto
                                    </Link>
                                    <br/>
                                    (o accede desde <Link style={{color: 'var(--enlace'}} to={`/compras`}>
                                    Mis Compras </Link>)
                                </span>
                            )  : (() => {
                                    const ahora = new Date();
                                    const fechaInicio = producto.FechaInicio;
                                    const fechaFin = producto.FechaFin ? new Date(producto.FechaFin) : null;
                            
                                    //Si el producto es una clase y ya ha finalizado
                                    if(producto.tipo === "clase" && fechaFin && fechaFin < ahora){
                                        return <span style={{ display: "block", paddingTop: "30px" }}>La clase ya ha finalizado</span>
                                    }

                                    //Producto no es una clase particular (no tiene fin y se crean sesiones por cada compra) y ya ha sido iniciada
                                    if(producto.tipo !== "claseParticular" && fechaInicio && fechaInicio < ahora){
                                        return <span style={{ display: "block", paddingTop: "30px" }}>No se permiten más inscripciones a esta clase</span>
                                    }

                                    //Comprobar aforo
                                    if (
                                        producto.tipo !== "claseParticular" &&
                                        producto.Plazas != null &&
                                        numVentas !== null &&
                                        numVentas >= producto.Plazas
                                    ) {
                                        return <span style={{ display: "block", paddingTop: "30px" }}>Aforo superado</span>;
                                    }

                                    //Mostrar botón de forma normal
                                    return (
                                        <button
                                            onClick={manejarAddCarrito}
                                            disabled={añadido}
                                        >
                                            {añadido ? "Ya en el carrito" : "Añadir al carrito"}
                                        </button>
                                    );
                                })()}
                        </div>

                    </div>
                
                    <div className="infoDerecha">
                        <div className="descripcionNombre">

                            <h1 style={{color: 'var(--text-principal)'}}>{producto.Nombre}</h1>
                            <h3>{tutor.Nombre} {tutor.Apellidos}</h3>

                            <div className="descripcionContenido">
                                <p>{producto.Descripcion}</p>
                            </div>
                        </div>

                        <div className="infoSecundaria">

                            <div className="detallesItem">
                                <h4 className="label">Temáticas: </h4>
                                <span className="value"><strong>{producto.Tematica?.join(", ")}</strong></span> 
                            </div>
                            
                            
                            <div className="detallesItem">
                                <h4 className="label">Fecha de publicación: </h4>
                                <span className="value">
                                    <strong>
                                        {new Date(producto.FechaSubida).toLocaleDateString("es-ES", {
                                            day: "2-digit",
                                            month: "2-digit",
                                            year: "numeric"
                                        })
                                        .replace(/\//g, "-")}
                                    </strong>
                                </span>
                            </div>

                            {producto.tipo === "curso" ? (

                                <div className="detallesItem">
                                    <h4 className="label">Duración: </h4> 
                                    <span className="value"><strong>{producto.Duracion} minutos</strong></span> 
                                </div>

                            ) : (
                                <div>
                                    <div className="detallesItem">
                                        <h4 className="label">Fecha de inicio: </h4> 
                                        <span className="value">
                                            <strong>
                                                {new Date(producto.FechaInicio).toLocaleDateString("es-ES", {
                                                    day: "2-digit",
                                                    month: "2-digit",
                                                    year: "numeric"
                                                })
                                                .replace(/\//g, "-")}
                                            </strong>
                                        </span>
                                    </div>
                                    
                                    
                                    <div className="detallesItem">
                                        <h4 className="label">Fecha de finalizacion: </h4> 
                                        <span className="value">
                                            <strong>
                                                {new Date(producto.FechaFin).toLocaleDateString("es-ES", {
                                                    day: "2-digit",
                                                    month: "2-digit",
                                                    year: "numeric"
                                                })
                                                .replace(/\//g, "-")}
                                            </strong>
                                        </span>
                                    </div> 
                                </div>
                            )}
                        </div>

                    </div>
                </div>
            </div>

            {producto.tipo === "curso" && archivos.length > 0 && (
            <div className="listarContenido"> 
                <h2>Contenido del curso</h2>
                <div className="lista">
                    <ul>
                        {archivos
                            .filter((archivo) => archivo.isDirectory)
                            .map((directorio) => (
                                <li key={directorio.nombre}>
                                    <strong>{getIcono(directorio)} {directorio.nombre.replace(/\/$/, "")} </strong>
                                    <ul>
                                        {archivos
                                            .filter((archivo) => archivo.nombre.startsWith(directorio.nombre) && !archivo.isDirectory)
                                            .map((archivo) => (
                                                <li key={archivo.nombre}>
                                                    <span>{getIcono(archivo)} {archivo.nombre.replace(`${directorio.nombre}`, "")} - Tamaño: {archivo.tamaño } KB. </span>
                                                </li>
                                            ))}
                                    </ul>
                                </li>
                        ))}

                        {archivos
                            .filter((archivo) => !archivo.isDirectory && !archivo.nombre.includes("/"))
                            .map((archivo) => (
                                <li key={archivo.nombre}>
                                    {getIcono(archivo)} {archivo.nombre} - Tamaño: {archivo.tamaño } KB.
                                </li>
                            ))}
                    </ul>
                </div>
            </div>
            )}

            {producto.tipo !== "curso" && sesiones.length > 0 && (
            <div className="listarContenido">
                <h2>Sesiones de la clase</h2>
                <div className="lista">
                    <ul>
                        {sesiones.map((sesion, index) => (
                            <li key={index}>
                                <span><SiGoogleclassroom /> {sesion.Parte}.- {sesion.Nombre} - Fecha:{" "} {
                                    (() => {
                                        const fecha = new Date(sesion.Fecha);
                                        const fechaStr = fecha.toLocaleDateString("es-ES", {
                                            day: "2-digit",
                                            month: "2-digit",
                                            year: "numeric"
                                        }).replace(/\//g, "-");
                                        const horaStr = fecha.toLocaleTimeString("es-ES", {
                                            hour: "2-digit",
                                            minute: "2-digit"
                                        });
                                        return `${fechaStr} a las ${horaStr}`;
                                    })()} - Duracion:{" "} {sesion.Duracion} minutos.
                                </span>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            )}

            <div className='infoResennas'>
                <h2>Reseñas</h2>
                <div className="containerResennas">
                    {resennas?.map((res) => (
                        <div  key={res?._id}>
                            <CardResennas resena={res} />
                        </div>
                    ))}
                </div>
            </div>

            <div className='contenidoRelacionado'>
                <h2>Contenido relacionado</h2>
                    <div className="swiperContainer">
                        <Swiper 
                            modules={[Pagination, Autoplay]}
                            loop={true}
                            autoplay={{
                                delay: 3000,
                                disableOnInteraction: false
                            }}
                            pagination={{
                                el: '.pagination',
                                clickable: true,
                            }}
                            slidesPerView={5}
                            centeredSlides={true}
                            spaceBetween={16}
                            breakpoints={{
                            0: {
                            slidesPerView: 1,
                            spaceBetween: 16
                            },
                            536: {
                            slidesPerView: 2,
                            spaceBetween: 16
                            },
                            792: {
                            slidesPerView: 3,
                            spaceBetween: 16
                            },
                            1048: {
                            slidesPerView: 4,
                            spaceBetween: 16
                            },
                            1304: {
                            slidesPerView: 5,
                            spaceBetween: 16
                            }
                        }}
                        >
                                {productosRelacionados?.filter(prodR =>
                                    prodR.Nombre !== null &&
                                    prodR.Tematica !== null &&
                                    prodR.Descripcion !== null &&
                                    prodR.FechaSubida !== null &&
                                    prodR.ImagenPortada !== null
                                ).map(prodR => { 
                                    return (
                                        <SwiperSlide key={prodR?._id}>
                                            <div style={{ height: "100%", marginLeft: "15px" }}>
                                                <Card producto={prodR} />
                                            </div>
                                        </SwiperSlide>
                                    );
                                })}   
                            <div className="pagination"></div>     
                        </Swiper>
                    </div>
            </div>
        </div>
   );
};

export default DetalleContenido;
